import { messagesManager } from "./Messages.slice";

export const messagesActions = { ...messagesManager.actions };
